import React from 'react';
import { ArrowRight } from 'lucide-react';
import type { Claim } from '../../types/researchDemo';
import { glassPanel, linkButton } from '../../utils/demoUi';
import { conceptById, predicateLabel } from '../../utils/researchDemo';
import { StatusPill } from './StatusPill';
type ClaimCardProps = {
  claim: Claim;
  actionLabel: string;
  onOpen: (claimId: string) => void;
};
export function ClaimCard({
  claim,
  actionLabel,
  onOpen
}: ClaimCardProps) {
  return <article className={`${glassPanel} flex h-full flex-col p-5`} data-id="element-1921" data-mp="2r1x1yvtssger">
      <div className="flex items-start justify-between gap-3" data-id="element-1922" data-mp="2w1rx5bklvs5m">
        <p className="font-mono text-xs font-semibold text-ink-muted" data-id="element-1923" data-mp="2i3uwa2z4czl5">
          {claim.id} · v{claim.version}
        </p>
        <StatusPill status={claim.status} data-id="element-1924" data-mp="2m3vmslzht18k" />
      </div>
      <h3 className="mt-3 font-heading font-bold leading-snug text-ink-dark" data-id="element-1925" data-mp="16o68xahydyjt">
        {conceptById(claim.subjectId)?.label} <span className="font-semibold text-lavender" data-id="element-1926" data-mp="1aphyxh4qolsj">{predicateLabel(claim.predicate)}</span>{' '}
        {conceptById(claim.objectId)?.label}
      </h3>
      <p className="mt-1 text-xs text-ink-muted" data-id="element-1927" data-mp="2nvz5lvfp8zt4">
        Source {claim.sourceId} · passage {claim.passageId}
      </p>
      <p className="mt-3 text-sm leading-relaxed text-ink-dark" data-id="element-1928" data-mp="2iyz1vr6bo956">
        <span className="font-semibold" data-id="element-1929" data-mp="2wxyq4xpxam0t">Limitation: </span>
        {claim.limitation}
      </p>
      <div className="mt-auto pt-4" data-id="element-1930" data-mp="2su0mc9pnkn1f">
        <button type="button" onClick={() => onOpen(claim.id)} className={linkButton} data-id="element-1931" data-mp="2sx6e5wpo230u">
          {actionLabel}
          <ArrowRight size={14} aria-hidden="true" data-id="element-1932" data-mp="31vrtzk3r73xx" />
          <span className="sr-only" data-id="element-1933" data-mp="31uyu9337pepa"> for {claim.id}</span>
        </button>
      </div>
    </article>;
}